import { Bar } from 'components/ui/LinearLoader/LinearLoaderStyles';
import styled from 'styled-components';
import { gradientYellowDark, gradientYellowLight, white } from 'styles/Colors';

export const PlaceholderPlayWrapper = styled.div`
  background: linear-gradient(112.13deg, #919191 0%, #dbdbdb 100%);
  border-radius: 5px;
  color: ${white};
  padding: 6px 9px 3px 9px;
  margin-bottom: 5px;
  cursor: pointer;

  &.selected {
    background: linear-gradient(112.13deg, ${gradientYellowDark} 0%, ${gradientYellowLight} 100%);
    ${Bar} {
      background: linear-gradient(140.12deg, ${gradientYellowDark} 0%, ${gradientYellowLight} 100%);
    }
  }

  &.hidden {
    display: none;
  }
`;

export const Batter = styled.div`
  font-family: Lato;
  font-size: 13px;
  line-height: 18px;
`;
export const Text = styled.div`
  font-family: Oswald;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  text-transform: uppercase;
  padding-bottom: 4px;
`;
export const Loader = styled.div`
  max-height: 25px;
  padding-bottom: 2px;

  ${Bar} {
    background: #a0a0a0;
  }
`;
